import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.parse-int";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getTimezones } from 'dynamic-data/timezones';
var cachedOffsets;
export var getOffsets = function getOffsets() {
  var offsets;

  if (__SERVER__) {
    var moment = require('moment-timezone');

    var tzStrToMinuteOffset = function tzStrToMinuteOffset(str) {
      return (parseInt(str.substring(1, 3), 10) * 60 + parseInt(str.substring(3, 5), 10)) * (str[0] === '-' ? 1 : -1);
    };

    offsets = getTimezones().reduce(function (memo, tz) {
      return _objectSpread({}, memo, _defineProperty({}, tz, tzStrToMinuteOffset(moment().tz(tz).format('ZZ'))));
    }, {});
  } else if (__CLIENT__) {
    if (!cachedOffsets) {
      var configNode = document.getElementById('tz-offsets');
      cachedOffsets = JSON.parse(configNode.textContent);
    }

    offsets = cachedOffsets;
  }

  if (!offsets) {
    throw new Error('Could not find TZ offsets.');
  }

  return offsets;
};

var isSupportedTimezone = function isSupportedTimezone(timezone) {
  return getTimezones().indexOf(timezone) >= 0;
};
/* Adds or subtracts an offset from a UTC timestamp to "shift" the timestamp
 * backwards or forwards so it renders correctly in the browser. JS's Date()
 * function treats all dates as UTC -- this works fine if you are looking at
 * a schedule for a venue in NYC on a computer set to EST. However, if you are
 * set to a DIFFERENT timezone from the studio, you'll see the class times in
 * *your* local timezone which is confusing.
 */


var shiftTimezone = function shiftTimezone(timestamp, timezone) {
  if (isSupportedTimezone(timezone)) {
    var browserOffset = new Date().getTimezoneOffset();
    var actualOffset = getOffsets()[timezone];
    var minuteDifference = actualOffset - browserOffset;
    return timestamp - minuteDifference * 60;
  }

  return timestamp;
};

export var shiftDateObjectByTimezone = function shiftDateObjectByTimezone(date, timezone) {
  return new Date(shiftTimezone(date.valueOf() / 1000, timezone) * 1000);
};
export default shiftTimezone;